import React, { useEffect, useContext } from "react";
import styled from "styled-components";
import { BounceLoader, FadeLoader, MoonLoader, SyncLoader, PropagateLoader, ClipLoader } from "react-spinners";

const LoaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FitLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Loader = ({ type = "ClipLoader", size = 28, color = "#5B8FBF", fit = false }) =>
  fit ? (
    <FitLoaderWrapper>
      {type === "BounceLoader" && <BounceLoader size={size} />}
      {type === "MoonLoader" && <MoonLoader size={size} />}
      {type === "SyncLoader" && <SyncLoader size={size} color={color} />}
      {type === "PropagateLoader" && <PropagateLoader size={size} />}
      {type === "FadeLoader" && <FadeLoader />}
      {type === "ClipLoader" && <ClipLoader color={color} size={size} />}
    </FitLoaderWrapper>
  ) : (
    <LoaderWrapper>
      {type === "BounceLoader" && <BounceLoader size={size} />}
      {type === "MoonLoader" && <MoonLoader size={size} />}
      {type === "SyncLoader" && <SyncLoader size={size} color={color} />}
      {type === "PropagateLoader" && <PropagateLoader size={size} />}
      {type === "FadeLoader" && <FadeLoader />}
      {type === "ClipLoader" && <ClipLoader color={color} size={size} />}
    </LoaderWrapper>
  );

export default Loader;
